import { lazy } from 'react';

const ResizeImageModal = lazy(() =>
  import('./ImageUploadAndResize/containers/ResizeImageModal'),
);
const VideoPlayerModal = lazy(() => import('./VideoPlayerDialog'));
const OrgAccessBlockedModal = lazy(() =>
  import('./LayoutV2/SideNav/MobileSideNav/OrgAccessBlockedModal'),
);
const UnsavedChangesModal = lazy(() =>
  import('./RouterPrompt/UnsavedChangesModal'),
);
const ColumnVisibilityModal = lazy(() => import('./ColumnVisibilityModal'));
const ImageUploadModal = lazy(() => import('./ImageUploadModal'));
const EmailTemplateModal = lazy(() => import('./EmailTemplateModal'));

export default {
  IMAGE_UPLOAD_AND_RESIZE: ResizeImageModal,
  ORG_ACCESS_BLOCKED: OrgAccessBlockedModal,
  VIDEO_PLAYER_MODAL: VideoPlayerModal,
  UNSAVED_CHANGES_MODAL: UnsavedChangesModal,
  COLUMN_VISIBILITY_MODAL: ColumnVisibilityModal,
  IMAGE_UPLOAD_MODAL: ImageUploadModal,
  EMAIL_TEMPLATE_MODAL: EmailTemplateModal,
};
